// extracted by mini-css-extract-plugin
export default {"header":"updateGlobalWalletSettingsModal_header__oxSOA","form":"updateGlobalWalletSettingsModal_form__JaMvP"};